import React from 'react';
import { get } from 'lodash';
import { SelectBox } from '../../molecules/select-box';
import { HDOMode } from '../../shared';
import { useSelector } from '../../store/utils';
import { FormattedMessage } from 'react-intl';
import { ParentPaper } from '../../atoms/parent-paper';
import { SwitchBox } from '../../molecules/switch-box';
import { SliderBox } from '../../molecules/slider-box';

export const HDOSettingsUser = () => {
  const weekendHDO = useSelector(
    (s) => get(s.variables, 'HDO_MODE') == 2 && get(s.variables, 'HDO_WEEKEND')
  );

  const spotPricePeriod = useSelector((s) =>
    get(s.variables, 'SP_PRICE_PERIOD')
  );
  const timeStep = spotPricePeriod === '15M' ? 900 : 3600;

  const optionsHDO = [
    {
      label: (
        <FormattedMessage
          id="settings.hdo.regular"
          defaultMessage="Běžný pracovní den"
        />
      ),
      value: HDOMode.Regular,
    },
    {
      label: (
        <FormattedMessage id="settings.hdo.weekend" defaultMessage="Víkend" />
      ),
      value: HDOMode.Weekend,
    },
  ];

  return (
    <>
      <ParentPaper>
        <SwitchBox
          title={
            <FormattedMessage
              id="settings.hdo.weekend"
              defaultMessage="Víkendové časy HDO"
            />
          }
          switchVariableId={'HDO_WEEKEND'}
          fullWidth
        />
        <SelectBox
          title={
            <FormattedMessage
              id="settings.hdo.type"
              defaultMessage="Definovat časy pro"
            />
          }
          visibility={{ variableId: 'HDO_WEEKEND' }}
          selectVariableId="HDO_MODE"
          options={optionsHDO}
          fullWidth
        ></SelectBox>
      </ParentPaper>
      {!weekendHDO && (
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on1" defaultMessage="Čas 1" />
            }
            switchVariableId={'HDO_ON[0]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START[0]'}
            visibility={{ variableId: 'HDO_ON[0]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP[0]'}
            visibility={{ variableId: 'HDO_ON[0]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on2" defaultMessage="Čas 2" />
            }
            switchVariableId={'HDO_ON[1]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START[1]'}
            visibility={{ variableId: 'HDO_ON[1]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP[1]'}
            visibility={{ variableId: 'HDO_ON[1]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on3" defaultMessage="Čas 3" />
            }
            switchVariableId={'HDO_ON[2]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START[2]'}
            visibility={{ variableId: 'HDO_ON[2]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP[2]'}
            visibility={{ variableId: 'HDO_ON[2]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on4" defaultMessage="Čas 4" />
            }
            switchVariableId={'HDO_ON[3]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START[3]'}
            visibility={{ variableId: 'HDO_ON[3]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP[3]'}
            visibility={{ variableId: 'HDO_ON[3]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on5" defaultMessage="Čas 5" />
            }
            switchVariableId={'HDO_ON[4]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START[4]'}
            visibility={{ variableId: 'HDO_ON[4]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP[4]'}
            visibility={{ variableId: 'HDO_ON[4]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on6" defaultMessage="Čas 6" />
            }
            switchVariableId={'HDO_ON[5]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START[5]'}
            visibility={{ variableId: 'HDO_ON[5]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP[5]'}
            visibility={{ variableId: 'HDO_ON[5]' }}
            step={timeStep}
            track={false}
          />
        </ParentPaper>
      )}
      {weekendHDO && (
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on1" defaultMessage="Čas 1" />
            }
            switchVariableId={'HDO_ON_WEEKEND[0]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START_WEEKEND[0]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[0]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP_WEEKEND[0]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[0]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on2" defaultMessage="Čas 2" />
            }
            switchVariableId={'HDO_ON_WEEKEND[1]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START_WEEKEND[1]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[1]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP_WEEKEND[1]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[1]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on3" defaultMessage="Čas 3" />
            }
            switchVariableId={'HDO_ON_WEEKEND[2]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START_WEEKEND[2]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[2]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP_WEEKEND[2]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[2]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on4" defaultMessage="Čas 4" />
            }
            switchVariableId={'HDO_ON_WEEKEND[3]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START_WEEKEND[3]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[3]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP_WEEKEND[3]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[3]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on5" defaultMessage="Čas 5" />
            }
            switchVariableId={'HDO_ON_WEEKEND[4]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START_WEEKEND[4]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[4]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP_WEEKEND[4]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[4]' }}
            step={timeStep}
            track={false}
          />
          <SwitchBox
            title={
              <FormattedMessage id="settings.hdo.on6" defaultMessage="Čas 6" />
            }
            switchVariableId={'HDO_ON_WEEKEND[5]'}
            fullWidth
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.start"
                defaultMessage="Zapnout"
              />
            }
            variableId={'HDO_TIME_START_WEEKEND[5]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[5]' }}
            step={timeStep}
            track={false}
          />
          <SliderBox
            type="time"
            title={
              <FormattedMessage
                id="settings.hdo.stop"
                defaultMessage="Vypnout"
              />
            }
            variableId={'HDO_TIME_STOP_WEEKEND[5]'}
            visibility={{ variableId: 'HDO_ON_WEEKEND[5]' }}
            step={timeStep}
            track={false}
          />
        </ParentPaper>
      )}
    </>
  );
};
